"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyTextProvider = void 0;
/* eslint-disable complexity */
const react_1 = __importDefault(require("react"));
const locale_1 = require("../locale");
const en_US_1 = __importDefault(require("./text/en-US"));
const PrivacyTextContext = react_1.default.createContext({
    ...en_US_1.default,
    headingReadMoreURL: ''
});
const getTextPromise = (locale) => {
    switch (locale) {
        case 'de-AT':
        case 'de-BE':
        case 'de-CH':
        case 'de-DE':
        case 'de-DE':
        case 'de-LI':
        case 'de-LU':
            return Promise.resolve().then(() => __importStar(require('./text/de-DE')));
        case 'en-AE':
        case 'en-AU':
        case 'en-BN':
        case 'en-BT':
        case 'en-BW':
        case 'en-CA':
        case 'en-GB':
        case 'en-HK':
        case 'en-IE':
        case 'en-IL':
        case 'en-KW':
        case 'en-MT':
        case 'en-PH':
        case 'en-QA':
        case 'en-SA':
        case 'en-SG':
        case 'en-TM':
        case 'en-US':
            return Promise.resolve().then(() => __importStar(require('./text/en-US')));
        case 'es-AD':
        case 'es-AR':
        case 'es-CL':
        case 'es-CO':
        case 'es-ES':
        case 'es-LATAM':
        case 'es-PE':
        case 'es-PY':
        case 'es-US':
            return Promise.resolve().then(() => __importStar(require('./text/es-ES')));
        case 'fr-BE':
        case 'fr-CA':
        case 'fr-CH':
        case 'fr-FR':
        case 'fr-LU':
        case 'fr-MC':
            return Promise.resolve().then(() => __importStar(require('./text/fr-FR')));
        case 'it-CH':
        case 'it-IT':
        case 'it-SM':
            return Promise.resolve().then(() => __importStar(require('./text/it-IT')));
        case 'ja-JP':
            return Promise.resolve().then(() => __importStar(require('./text/ja-JP')));
        case 'ko-KR':
            return Promise.resolve().then(() => __importStar(require('./text/ko-KR')));
        case 'nl-BE':
        case 'nl-NL':
            return Promise.resolve().then(() => __importStar(require('./text/nl-NL')));
        case 'pt-BR':
        case 'pt-PT':
            return Promise.resolve().then(() => __importStar(require('./text/pt-BR')));
        case 'zh-HK':
        case 'zh-SG':
        case 'zh-TW':
            // TODO: SPKVX-882 we need Chinese translations
            return Promise.resolve().then(() => __importStar(require('./text/en-US')));
    }
};
const getPrivacyURLLocale = (locale) => {
    switch (locale) {
        case 'de-CH':
            return 'de-CH';
        case 'de-AT':
        case 'de-BE':
        case 'de-LI':
        case 'de-LU':
        case 'de-DE':
            return 'de-DE';
        case 'en-AE':
        case 'en-BN':
        case 'en-BT':
        case 'en-BW':
        case 'en-IE':
        case 'en-IL':
        case 'en-KW':
        case 'en-MT':
        case 'en-PH':
        case 'en-QA':
        case 'en-SA':
        case 'en-TM':
        case 'en-AU':
            return 'en-AU';
        case 'en-CA':
            return 'en-CA';
        case 'pt-PT':
        case 'en-GB':
            return 'en-GB';
        case 'en-HK':
            return 'en-HK';
        case 'en-SG':
            return 'en-SG';
        case 'en-US':
            return 'en-US';
        case 'es-AD':
        case 'es-ES':
            return 'es-ES';
        case 'es-AR':
        case 'es-CL':
        case 'es-CO':
        case 'es-PE':
        case 'es-PY':
        case 'es-LATAM':
            return 'es-LATAM';
        case 'es-US':
            return 'en-US';
        case 'fr-CA':
            return 'fr-CA';
        case 'fr-CH':
            return 'fr-CH';
        case 'fr-BE':
        case 'fr-LU':
        case 'fr-MC':
        case 'fr-FR':
            return 'fr-FR';
        case 'it-CH':
            return 'it-CH';
        case 'it-SM':
        case 'it-IT':
            return 'it-IT';
        case 'ja-JP':
            return 'ja-JP';
        case 'ko-KR':
            return 'ko-KR';
        case 'nl-BE':
        case 'nl-NL':
            return 'nl-NL';
        case 'pt-BR':
            return 'pt-BR';
        case 'zh-HK':
            return 'zh-HK';
        case 'zh-SG':
            return 'zh-SG';
        case 'zh-TW':
            return 'zh-TW';
    }
};
const PrivacyTextProvider = ({ children, locale, readMoreURL }) => {
    const [text, setText] = react_1.default.useState({
        ...en_US_1.default,
        headingReadMoreURL: ''
    });
    const textPromise = react_1.default.useMemo(() => {
        const localeSupported = locale_1.locales.includes(locale) ? locale : 'en-US';
        return getTextPromise(localeSupported);
    }, [locale]);
    const headingReadMoreURL = readMoreURL !== null && readMoreURL !== void 0 ? readMoreURL : `https://www.modernatx.com/${getPrivacyURLLocale(locale)}/cookie-statement`;
    react_1.default.useEffect(() => {
        textPromise.then((result) => setText({
            ...result.default,
            headingReadMoreURL
        }));
    }, [locale, textPromise, headingReadMoreURL]);
    return react_1.default.createElement(PrivacyTextContext.Provider, { value: text }, children);
};
exports.PrivacyTextProvider = PrivacyTextProvider;
const usePrivacyText = () => {
    return react_1.default.useContext(PrivacyTextContext);
};
exports.default = usePrivacyText;
